

export const routes = [
    {
        name: 'index',
        path: ['/', '/inicio', '/:lang', '/:lang/inicio'],
        page: 'home'
    },
    {
        name: 'contacto',
        path: ['/contacto', '/contact', '/:lang/contacto', '/:lang/contact'],
        page: 'contact'
    },
    {
        name: 'aliados',
        path: ['/aliados', '/partners', '/:lang/aliados', '/:lang/partners'],
        page: 'allies'
    },
    {
        name: 'blog',
        path: ['/blog', '/:lang/blog'],
        page: 'blog'
    },
    {
        name: 'detailBlog',
        path: ['/:lang/detailblog', '/:lang/blog/:path'],
        page: 'detailBlog'
    },
    {
        name: 'Solution',
        path: ['/calera', '/apan', '/cdmx', '/:lang/calera', '/:lang/apan', '/:lang/cdmx'],
        page: 'solution'
    },
    {
        name: 'gallery',
        path: ['/galeria', '/:lang/galeria'],
        page: 'gallery'
    },
    {
        name: 'register',
        path: ['/registro', '/:lang/registro'],
        page: 'register'
    },
    {
        name: 'login',
        path: ['/inicio-sesion', '/:lang/inicio-sesion'],
        page: 'login'
    },
    {
        name: 'participante',
        path: ['/participar', '/:lang/participar'],
        page: 'participanteform'
    },
    {
        name: 'ranking',
        path: ['/ranking', '/:lang/ranking'],
        page: 'ranking'
    },
    {
        name: 'legals',
        path: ['/bases-concurso', '/:lang/bases-concurso'],
        page: 'legals'
    },
    {
        name: 'galery',
        path: ['/galeria', '/:lang/galeria'],
        page: 'galery'
    },
    {
        name: 'biblioteca',
        path: ['/biblioteca', '/:lang/biblioteca'],
        page: 'biblioteca'
    },
]